import React, { FC } from 'react'
import { useWatch } from 'react-hook-form'
import ControlledRadioGroupInput from 'transfix-form/components/ControlledRadioGroupInput'
import { Box, makeStyles } from 'transfix-ui/core'
import { IIssueAutomationRuleActionEnum } from 'types/graphqlTypes'
import { brandColors, FormModal, InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui'
import { TSelectRuleTypeSchema, useSelectRuleTypeForm } from './SelectRuleTypeForm'

export interface ISelectRuleTypeModal {
  onClose: () => void
  onContinue: (ruleType: string) => void
}

export const RULE_TYPE_OPTIONS = [
  {
    label: 'Open Issue Rule',
    id: IIssueAutomationRuleActionEnum.create,
  },
  {
    label: 'Close Issue Rule',
    id: IIssueAutomationRuleActionEnum.resolve,
  },
]

const useStyles = makeStyles(theme => ({
  form: {
    '& label': {
      height: 50,
      backgroundColor: brandColors.coolGray1,
      '&:hover': {
        backgroundColor: brandColors.skyBlue1,
      },
      margin: 0,
      marginBottom: theme.spacing(1),
      borderRadius: 5,
    },
  },
}))

export const SelectRuleTypeModal: FC<ISelectRuleTypeModal> = ({ onClose, onContinue }) => {
  const classes = useStyles()
  const { control, handleSubmit } = useSelectRuleTypeForm()

  const selectedRuleType = useWatch({
    name: 'ruleType',
    control,
  })

  const handleContinue = (formData: TSelectRuleTypeSchema) => {
    onContinue(formData.ruleType)
  }

  return (
    <FormModal
      size={4}
      open
      onClose={onClose}
      title='Select an Automation Type:'
      actions={[
        {
          label: 'Cancel',
          type: 'dismiss',
          action: onClose,
        },
        {
          label: 'Continue',
          type: 'confirm',
          action: handleSubmit(handleContinue),
          disabled: !selectedRuleType,
          dataTest: 'select-rule-type-continue',
        },
      ]}>
      <Box mb={3} className={classes.form}>
        <ControlledRadioGroupInput
          control={control}
          name='ruleType'
          options={RULE_TYPE_OPTIONS}
          RadioProps={{
            dataTest: 'rule-type-radio',
          }}
        />
      </Box>
      <InlineMessage
        fullWidth
        message='Automations may take up to 10 minutes to execute.'
        type={INLINE_MESSAGE_VARIANTS.INFO}
        dataTest='issue-automation-info-message'
      />
    </FormModal>
  )
}
